/**
* Project janux-vuejs-seed
* Created by hielo on 2018-04-18
*/

<template lang="pug">
div#app
	router-view
	info-dialog
	notifications(group='app')
	vue-progress-bar
</template>

<script>
export default {
	name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/app/AppComponent.vue